var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 211 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st0",
    d: "M128.7,40.8h6.1L127.7,63h-5.5l-4.1-13.5L114.1,63h-5.5l-7.1-22.2h6.1l3.8,13.7l4-13.7h5.4l4,13.7L128.7,40.8z  M153.9,40.8h5.7V63h-5.7v-2.6c-1.7,2.2-4.1,3.2-7.3,3.2c-3,0-5.5-1.1-7.7-3.4c-2.1-2.3-3.2-5.1-3.2-8.4c0-3.3,1.1-6.1,3.2-8.3 c2.1-2.3,4.7-3.4,7.7-3.4c3.1,0,5.5,1.1,7.3,3.2V40.8z M143.4,56.4c1.2,1.2,2.6,1.7,4.4,1.7c1.8,0,3.2-0.6,4.4-1.7 c1.2-1.2,1.8-2.7,1.8-4.5s-0.6-3.3-1.8-4.5c-1.2-1.2-2.6-1.8-4.4-1.8c-1.8,0-3.2,0.6-4.4,1.8c-1.2,1.2-1.7,2.7-1.7,4.5 S142.2,55.2,143.4,56.4z M170.6,44.6c0.5-1.4,1.4-2.5,2.6-3.2c1.2-0.7,2.6-1.1,4.1-1.1v6.4c-1.8-0.2-3.3,0.1-4.7,1.1 c-1.4,0.9-2,2.4-2,4.6V63h-5.7V40.8h5.7V44.6z M193.7,40.1c3,0,5.5,1.1,7.7,3.4c2.1,2.3,3.2,5,3.2,8.3c0,3.3-1.1,6.1-3.2,8.4 c-2.1,2.3-4.7,3.4-7.7,3.4c-3.1,0-5.5-1.1-7.2-3.2v11.5h-5.7V40.8h5.7v2.6C188.2,41.2,190.6,40.1,193.7,40.1z M188.2,56.4 c1.2,1.2,2.6,1.7,4.4,1.7c1.8,0,3.2-0.6,4.4-1.7c1.2-1.2,1.8-2.7,1.8-4.5s-0.6-3.3-1.8-4.5c-1.2-1.2-2.6-1.8-4.4-1.8 c-1.8,0-3.2,0.6-4.4,1.8c-1.2,1.2-1.7,2.7-1.7,4.5S187.1,55.2,188.2,56.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st0",
    d: "M87.6,51.4c-0.1,0.1-5.2,6.1-12,6.2c-4,0.1-7.9-2-11.6-6.2c-5-5.6-10.5-8.4-16.3-8.3c-9.4,0.2-16.1,8-16.4,8.4 c-3.7,4.2-7.6,6.3-11.7,6.2c-6.7-0.1-11.9-6.1-12-6.2L3,56.4c0.3,0.3,7,8.3,16.5,8.4c0.1,0,0.2,0,0.3,0c5.7,0,11.1-2.8,16.1-8.4 c0.1-0.1,5.3-6.2,12-6.3c4-0.1,8,2,11.7,6.2c4.9,5.5,10.3,8.4,16,8.4h0.3c9.5-0.2,16.2-8.1,16.5-8.4L87.6,51.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st0",
    d: "M47.6,79c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10s-10,4.5-10,10C37.7,74.5,42.1,79,47.6,79z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st0",
    d: "M19.5,49.8c5.5,0,10-4.5,10-10s-4.5-10-10-10c-5.5,0-10,4.5-10,10S14,49.8,19.5,49.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st0",
    d: "M75.5,49.8c5.5,0,10-4.5,10-10s-4.5-10-10-10c-5.5,0-10,4.5-10,10S70,49.8,75.5,49.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarp);
export default __webpack_public_path__ + "static/media/Warp.6133714034fb055405dfa8f62de6fec6.svg";
export { ForwardRef as ReactComponent };